import { OverridingExperimentClient } from './overriding.js';
import { FallbackExperimentClient } from './fallback.js';
import { TrackingExperimentClient } from './tracking-browser.js';
import { GraphQLExperimentClient } from './graphql.js';
import { RecordingExperimentClient } from './recording.js';

var graphQLExperimentClient = undefined;
var apolloClient = undefined;
function createServerExperimentClient(config) {
    var client;
    if (config.graphqlConfig) {
        apolloClient = config.graphqlConfig.apolloClient;
        if (!graphQLExperimentClient) {
            graphQLExperimentClient = new GraphQLExperimentClient({
                apolloClient: function () { return apolloClient; },
                fetchUpdatesIntervalMillis: config.graphqlConfig.fetchUpdatesIntervalMillis
            });
        }
        client = graphQLExperimentClient;
    }
    else {
        throw 'Split IO Config or Apollo Client needs to be set';
    }
    if (config.forceDefaultTreatments || config.experimentOverrides) {
        client = new OverridingExperimentClient(client, config);
    }
    if (config.recordedExperiments) {
        client = new RecordingExperimentClient(client, config.recordedExperiments);
    }
    return client;
}
function createBrowserExperimentClient(config) {
    var client;
    if (config.graphqlConfig) {
        client = new GraphQLExperimentClient(config.graphqlConfig);
    }
    else {
        throw 'Apollo Client needs to be set';
    }
    if (config.fallback) {
        client = new FallbackExperimentClient(client, config.fallback);
    }
    if (config.forceDefaultTreatments || config.experimentOverrides) {
        client = new OverridingExperimentClient(client, config);
    }
    if (config.onExperimentViewed) {
        client = new TrackingExperimentClient(client, config);
    }
    return client;
}

export { createBrowserExperimentClient, createServerExperimentClient };
//# sourceMappingURL=index.js.map
